import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetTheAppraisalRetrieveActions,
  SetTheAppraisalditsActions,
} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
const AppraisalEdit = (props) => {
  const { currentPage, setShow, show, EditId , white_collar , from_date , to_date  , search} = props;
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const initialState = {
    emp_except: "",
    purpose: "",
    status: "",
    Name: "",
    email: "",
    request_type: "",
    client_name: "",
    description: "",
  };
  const [data, setData] = useState(initialState);
  useEffect(() => {
    const payload = {
      EditId: EditId,
    };
    dispatch(SetTheAppraisalRetrieveActions(payload));
  }, []);
  useEffect(() => {
    console.log(
      state.AppraisalRetrieveCall.Appraisalretrieve,
      "AppraisalRetrieveCall"
    );
    if (
      state.AppraisalRetrieveCall.Appraisalretrieve != undefined &&
      // state.AppraisalRetrieveCall.Appraisalretrieve.client_id != undefined &&
      // state.AppraisalRetrieveCall.Appraisalretrieve.client_id.client_name !=
      //   undefined &&
      state.AppraisalRetrieveCall.Appraisalretrieve.user_id != undefined &&
      state.AppraisalRetrieveCall.Appraisalretrieve.user_id.first_name !=
        undefined
    ) {
      setData({
        ...data,
        emp_except: state.AppraisalRetrieveCall.Appraisalretrieve.emp_except,
        purpose: state.AppraisalRetrieveCall.Appraisalretrieve.purpose,
        status: state.AppraisalRetrieveCall.Appraisalretrieve.status,
        Name: state.AppraisalRetrieveCall.Appraisalretrieve.user_id.first_name,
        email: state.AppraisalRetrieveCall.Appraisalretrieve.user_id.email,
        request_type:
          state.AppraisalRetrieveCall.Appraisalretrieve.request_type,
        client_name:
        state.AppraisalRetrieveCall.Appraisalretrieve.client_id != undefined &&
      state.AppraisalRetrieveCall.Appraisalretrieve.client_id.client_name !=
        undefined  ? 
          state.AppraisalRetrieveCall.Appraisalretrieve.clWient_id.client_name :"",
        description:
          state.AppraisalRetrieveCall.Appraisalretrieve.reason_for_decline,
      });
    }
  }, [state.AppraisalRetrieveCall.Appraisalretrieve]);

  const HandleChanges = (e) => {
    setData({
      ...data,
      status: e.target.value,
    });
  };
  const HandleDecriptions = (e) => {
    setData({
      ...data,
      description: e.target.value,
    });
  };

  const handleClose = () => {
    setShow(false);
  };
  const HandleClick = () => {
     if(data.status != ""){ 
    const payload = {
      status: data.status.toLowerCase(),
      description: data.description,
      EditId: EditId,
      currentPage: currentPage,
      white_collar:white_collar, 
      // month: Datestate.month,
      // year: Datestate.year,
      // date:Datestate.date , 

      from_date:from_date , to_date:to_date , 
      search:search, 
    };
    dispatch(SetTheAppraisalditsActions(payload, props.setShow()));
  }
  };
  const Options = [
    {
      id: 1,
      Status: "Approved",
    },
    {
      id: 2,
      Status: "Decline",
    },
    {
      id: 3,
      Status: "Pending",
    },
  ];

  return (
    <>
      <div className={`${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
        <div className="col BodyContent LeaveEdits">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <span>Appraisal Requested Employee</span>
                      <div
                        className="CloseIcon"
                        onClick={(e) => setShow(false)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>
                    <div className="Modal-Body Modal-bodyUserCRUD">
                      <div className="row">
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={data.Name}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Email
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={data.email}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Client name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={data.client_name}
                            name="last_name"
                            readOnly
                          />
                        </div>
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Purpose
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={data.purpose}
                            name="last_name"
                            readOnly
                          />
                        </div>
                   
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            employee Expect
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={data.emp_except}
                            name="last_name"
                            readOnly
                          />
                        </div>
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Request Type
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={data.request_type}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Status
                          </label>

                          <select
                            class="form-select form-select-lg col-12"
                            aria-label=".form-select-lg example"
                            onChange={HandleChanges}
                            /// value={Data.status}
                          >
                            {Options.map((item) => (
                              <option
                                selected={
                                  data.status.toLowerCase() ==
                                  item.Status.toLowerCase()
                                }
                                value={item.Status}
                              >
                                {item.Status}
                              </option>
                            ))}
                          </select>
                        </div>
                        {data.status.toLowerCase() == "decline" ? (
                          <>
                            <div
                              className="col-sm-3 mt-3"
                              style={{ width: "700px" }}
                            >
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Reason for decline
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                required
                                autocomplete="off"
                                name="description"
                                value={data.description}
                                onChange={HandleDecriptions}
                              />
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>

                    <div className="UserButtons">
                      <button
                        class="btn  SaveBtn"
                        type="submit"
                        onClick={(e) => {
                          HandleClick(e);
                        }}
                      >
                        Submit 
                      </button>
                      <button
                        class="btn CancelBtn"
                        onClick={(e) => handleClose(e)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppraisalEdit;
